import {differenceInWeeks, format, isToday, isYesterday} from "date-fns";

export function formatChatDate(date) {
    const createAt = new Date(date);
    const currentDate = new Date();

    if (isToday(createAt)) {
        return "Today, " + format(new Date(date), "hh:mm aaa");
    }

    if (isYesterday(createAt)) {
        return "Yesterday, " + format(new Date(date), "hh:mm aaa");
    }

    if (differenceInWeeks(currentDate, createAt) < 1) {
        return format(new Date(date), "EEE, hh:mm aaa");
    }

    return format(new Date(date), "MMM dd, hh:mm aaa");
}
